@if (appFacadeService.getSubActiveTab() | async; as tab) {
<div>
    <div [hidden]="tab !== 'Default'">
        <ng-container [ngTemplateOutlet]="accountList"></ng-container>
    </div>
    <div [hidden]="tab !== 'AccountContactList'">
        <ng-container [ngTemplateOutlet]="accountContactList"></ng-container>
    </div>
</div>
}
<ng-template #accountList>
    <div class="wrapper holder">
        <div class="container">
            @if (consumers$ | async; as consumerData) {
            <div [ngClass]="{ hide: (loading$ | async) === true }">
                <div class="account-list-header">
                    <div class="search">
                        <por-search-box
                            class="amount-control"
                            label="{{ 'Text Search' | translate }}"
                            [placeholder]="'Quick search Company Name, City, Account #' | translate"
                            [value]="consumerData.search"
                            (searched)="setSearch($any($event))"></por-search-box>
                    </div>
                </div>
                <div class="list-wrapper">
                    <por-lists
                        (generateLink)="generateQuickLink($event)"
                        (viewContacts)="viewContacts($event)"
                        [noMoreRecord]="$any(consumerData.noMoreRecord)"
                        (loadMore)="loadMore()"
                        [consumers]="consumerData.records"></por-lists>
                </div>
            </div>
            } @if ((loading$ | async) === true) {
            <ng-container [ngTemplateOutlet]="loading"></ng-container>
            }
        </div>
    </div>
</ng-template>
<ng-template #accountContactList>
    @if (appFacadeService.getCustomerContacts() | async; as data) {
    <div class="wrapper holder">
        <div class="container">
            <div class="content">
                <por-contacts [consumer]="selectedConsumer()" (closePanel)="closeContact()" [consumerContacts]="data"></por-contacts>
            </div>
        </div>
    </div>
    }
</ng-template>
<ng-template #loading>
    <por-busy-indicator [message]="'Loading' | translate" />
</ng-template>
